// app-routing.module.ts
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { PagesComponent } from './pages/pages.component';
import { HomeComponent } from './pages/home/home.component';
import { AuthGuard } from './guards/auth.guard';
import { RoutesInitializerGuard } from './guards/routes-initializer.guard';

// Rutas mínimas iniciales - el guard cargará las dinámicas
const routes: Routes = [
  { 
    path: '', 
    redirectTo: 'login', 
    pathMatch: 'full'
  },
  { 
    path: 'login', 
    component: LoginComponent
  },
  { 
    path: 'home', 
    component: PagesComponent,
    canActivate: [AuthGuard],
    children: [{ path: "comisiones", component: HomeComponent }]
  },
  // Todas las demás rutas pasan por el guard que carga las dinámicas
  {
    path: '**',
    canActivate: [RoutesInitializerGuard],
    children: [] // Se llenarán dinámicamente
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }